<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="$t('Add') + ' ' +  $t('a.intervention')"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <b-form @submit.stop.prevent="onSubmit">
<!--region address-->
          <div class="row">
            <div class="col-lg-8 col-sm-12">
              <SelectAutoCompleteField
                :title="$t('AddressIntervention')+'*'"
                urlData="/addressIntervention/getSuggestions"
                @setTagValue="setAddressIntervention"
                :init-value="addressIntervention"
              >
              </SelectAutoCompleteField>
            </div>
            <div class="col-lg-4 col-sm-12 d-flex align-items-center justify-content-end">
              <b-form-group label=" ">
                <b-button type="button" variant="thirdly" @click="showCreateAddressInterventionModal">+ {{$t('new.intervention.address')}} </b-button>
              </b-form-group>
            </div>
          </div>
          <div class="line-separator mb-3"></div>

<!--endregion-->
<!--region Infos-->
          <div class="row">
            <b-form-group
              id="type-input"
              :label="$t('intervention.Type')+'*'"
              label-for="type-input"
              class="bold-label col-12 col-md-6 mb-4"
              :invalid-feedback="form.type.invalidFeedback"
              :state="form.type.state"
            >
              <b-form-select
                id="type-input"
                v-model="form.type.value"
                :options="interventionTypes"
                :state="form.type.state"
                required
              ></b-form-select>
            </b-form-group>

            <b-form-group
              id="technician-input"
              :label="$t('intervention.Technician')+'*'"
              label-for="technician-input"
              class="bold-label col-12 col-md-6 mb-4"
              :invalid-feedback="form.technician.invalidFeedback"
              :state="form.technician.state"
            >
              <b-form-select
                id="technician-input"
                v-model="form.technician.value"
                :options="technicians"
                :state="form.technician.state"
                required
              ></b-form-select>
            </b-form-group>

            <b-form-group
              id="applicant-input"
              :label="$t('Applicant')+'*'"
              label-for="applicant-input"
              class="bold-label col-12 col-md-6 mb-4"
              :invalid-feedback="form.applicant.invalidFeedback"
              :state="form.applicant.state"
            >
              <b-form-select
                id="applicant-input"
                v-model="form.applicant.value"
                :options="applicantOptions"
                :state="form.applicant.state"
                :disabled="applicantOptions.length <= 1"
                required
              ></b-form-select>
            </b-form-group>

            <b-form-group
              id="device-input"
              :label="$t('device.concerned')"
              label-for="device-input"
              class="bold-label col-12 col-md-6 mb-4"
              :invalid-feedback="form.device.invalidFeedback"
              :state="form.device.state"
            >
              <b-form-select
                id="technician-input"
                v-model="form.device.value"
                :options="deviceOptions"
                :state="form.device.state"
                :disabled="deviceOptions.length <= 1"
              ></b-form-select>
            </b-form-group>

            <date-field
              :dateName="$t('intervention.StartDate')"
              :isRequired="true"
              @dateInfos="getEstimatedStartDateInfos"
              :min-date="minDate"
            >
            </date-field>

            <date-field
              :dateName="$t('intervention.EndDate')"
              :isRequired="true"
              @dateInfos="getEndDateInfos"
              :min-date="minDate"
              :init-value="automaticEndDate"
            >
            </date-field>

            <b-form-group
              id="description-input"
              :label="$t('intervention.Description')"
              label-for="description-input"
              class="bold-label col-12 mb-4"
              :invalid-feedback="form.description.invalidFeedback"
              :state="form.description.state"
            >
              <b-form-textarea
                id="description-input"
                v-model="form.description.value"
                type="text"
                maxlength="5000"
                :state="form.description.state"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <div class="line-separator mb-3"></div>
<!--endregion-->
<!--region billing address-->
          <div class="row">
            <div class="col-12">

              <div class="mb-3">
                <b-form-checkbox
                  id="useAddressInterventionForBilling-input"
                  v-model="useAddressInterventionForBilling"
                >
                  <div class="bold-text"> {{$t('use.address.intervention.for.billing')}}</div>
                </b-form-checkbox>
              </div>

              <b-form-group
                id="billingAddress-input"
                :label="$t('applicant.address')+'*'"
                label-for="billingAddress-input"
                class="bold-label"
                :invalid-feedback="form.billingAddress.invalidFeedback"
                :state="form.billingAddress.state"
              >
                <b-form-input
                  id="billingAddress-input"
                  :placeholder="$t('number.and.address')"
                  v-model="form.billingAddress.value"
                  type="text"
                  maxlength="250"
                  :state="form.billingAddress.state"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-12">
              <b-form-group
                id="billingAdditionalAddress-input"
                :label="$t('addressIntervention.AdditionalAddress')"
                label-for="billingAdditionalAddress-input"
                class="bold-label"
                :invalid-feedback="form.billingAdditionalAddress.invalidFeedback"
                :state="form.billingAdditionalAddress.state"
              >
                <b-form-input
                  id="billingAdditionalAddress-input"
                  :placeholder="$t('addressIntervention.AdditionalAddress')"
                  v-model="form.billingAdditionalAddress.value"
                  type="text"
                  maxlength="250"
                  :state="form.billingAdditionalAddress.state"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-6">
              <b-form-group
                id="billingPostalCode-input"
                :label="$t('addressIntervention.postalCode')+'*'"
                label-for="billingPostalCode-input"
                class="bold-label"
                :invalid-feedback="form.billingPostalCode.invalidFeedback"
                :state="form.billingPostalCode.state"
              >
                <b-form-input
                  id="billingPostalCode-input"
                  :placeholder="$t('addressIntervention.postalCode')"
                  v-model="form.billingPostalCode.value"
                  type="text"
                  maxlength="250"
                  :state="form.billingPostalCode.state"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-6">
              <b-form-group
                id="billingCity-input"
                :label="$t('addressIntervention.city')+'*'"
                label-for="billingCity-input"
                class="bold-label"
                :invalid-feedback="form.billingCity.invalidFeedback"
                :state="form.billingCity.state"
              >
                <b-form-input
                  id="billingCity-input"
                  :placeholder="$t('addressIntervention.city')"
                  v-model="form.billingCity.value"
                  type="text"
                  maxlength="250"
                  :state="form.billingCity.state"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <b-form-checkbox
                  id="recordBillingToApplicant-input"
                  v-model="form.recordBillingToApplicant.value"
                  :state="form.recordBillingToApplicant.state"
                >
                  <div> {{$t('record.billing.to.applicant')}}</div>
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <div class="line-separator mb-3 mt-2"></div>
          <!--          endregion-->
<!--region Documents -->
          <div class="row">
            <div class="col-6">
              <b-form-group
                class="bold-label"
                label="Photo ou document"
                label-for="file-input"
                :state="form.file.state"
                :invalid-feedback="form.file.invalidFeedback"
              >
                <b-form-file
                  id="file-input"
                  class="mt-1"
                  accept="image/jpeg, image/png, .pdf, .docx, .odt, .doc"
                  placeholder="Photo ou document..."
                  drop-placeholder="Glisser le fichier ici"
                  v-model="form.file.value"
                  :state="form.file.state"
                ></b-form-file>
              </b-form-group>

              <div v-if="this.files != null" class="bold-label col-12">
                <div v-for="(file, index) in this.files" :key=index>

                  <div v-if="file.type === 'DOCUMENT'" class="mt-2 position-relative">
                    <file-text-icon/>
                    <a :href=file.url target="_blank">{{ file.name }}</a>
                    <b-button @click="removeFile(file)" class="btn-icon remove-photo-icon">
                      <trash-icon></trash-icon>
                    </b-button>
                  </div>
                  <div v-if="file.type === 'PHOTO'" class="mt-2 position-relative">
                    <photo-icon/>
                    <b-link @click="zoomOnImage(file.url)"> {{ file.name }}</b-link>
                    <b-button @click="removeFile(file)" class="btn-icon remove-photo-icon">
                      <trash-icon></trash-icon>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
<!--endregion-->
        <div class="row">
          <div class="d-flex justify-content-end end col-12" style="flex: auto; align-items: flex-start;">
            <b-button type="submit" variant="primary" :disabled="isSending">{{ $t('Validate') }}</b-button>
          </div>
        </div>

        </b-form>
      </b-card>
    </b-container>
    <AddressInterventionCreateModal @didCreateAddressIntervention="didCreateAddressIntervention"></AddressInterventionCreateModal>
    <!-- Modal Zoom on image -->
    <zoom-on-image v-if="ui.zoomOnImageSrc !== null" :src="ui.zoomOnImageSrc" @didCloseZoomOnImage="didCloseZoomOnImage"></zoom-on-image>
  </div>
</template>


<script>

import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import DateField from "../../components/b122/DateField";
import SelectAutoCompleteField from "../../components/SelectAutoCompleteField";
import AddressInterventionCreateModal from "../addressIntervention/AddressInterventionCreateModal";
import {dateUtils} from "../../mixins/utils";
import ZoomOnImage from "../../components/b122/ZoomOnImage";

export default {
  name: 'InterventionCreate',

  mixins: [dateUtils],

  components: {
    BackArrow,
    DateField,
    AddressInterventionCreateModal,
    SelectAutoCompleteField,
    ZoomOnImage
  },

  data() {
    return {
      files: [],
      addressIntervention: null,
      useAddressInterventionForBilling: false,
      applicant: null,
      applicantOptions: [],
      deviceOptions: [],
      technicians: [],
      interventionTypes: [],
      minDate: new Date(),
      automaticEndDate: null,
      isSending: false,
      form: {
        technician: {
            state: null,
            invalidFeedback: null,
            value: null
          },
        applicant:{
            state: null,
            invalidFeedback: null,
            value: null
          },
        device: {
            state: null,
            invalidFeedback: null,
            value: null
          },
        description: {
            state: null,
            invalidFeedback: null,
            value: null
          },
        estimatedEndDate: {
            state: null,
            invalidFeedback: null,
            value: null
          },
        estimatedStartDate: {
            state: null,
            invalidFeedback: null,
            value: null
          },
        type: {
            state: null,
            invalidFeedback: null,
            value: null
          },
        billingAddress:{
            state: null,
            invalidFeedback: null,
            value: null
          },
        billingPostalCode:{
            state: null,
            invalidFeedback: null,
            value: null
          },
        billingCity:{
            state: null,
            invalidFeedback: null,
            value: null
          },
        billingAdditionalAddress:{
            state: null,
            invalidFeedback: null,
            value: null
          },
        recordBillingToApplicant:{
            state: null,
            invalidFeedback: null,
            value: false
          },
        file: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      },
      ui: {
        zoomOnImageSrc: null
      }
    }
  },

  mounted() {
    this.$route.params.selectedAddressIntervention != null ? this.addressIntervention = this.$route.params.selectedAddressIntervention : null
    if(this.$route.params.selectedApplicant != null){
      this.applicant = this.$route.params.selectedApplicant.id
      this.form.applicant.value = this.$route.params.selectedApplicant.id
    }
    this.setOptionField()
  },

  watch: {
    'addressIntervention':function () {
      this.deviceOptions = [{value: null, text: this.$i18n.t('device.select'), disabled: true}]
      this.applicantOptions = [{value: null, text: this.$i18n.t('applicant.select'), disabled: true}]
      if(this.addressIntervention != null){
        if(this.addressIntervention.tenant != null) this.applicantOptions.push({value: this.addressIntervention.tenant.id, text: this.addressIntervention.tenant.name})
        if(this.addressIntervention.owner != null) this.applicantOptions.push({value: this.addressIntervention.owner.id, text: this.addressIntervention.owner.name})
        if(this.addressIntervention.agency != null) this.applicantOptions.push({value: this.addressIntervention.agency.id, text: this.addressIntervention.agency.name})
        this.fetchDevices()
      }
      this.resetBillingAddress()
      if(this.useAddressInterventionForBilling){
        this.form.billingAddress.value = this.addressIntervention.address
        this.form.billingPostalCode.value  = this.addressIntervention.postalCode
        this.form.billingCity.value  = this.addressIntervention.city
        this.form.billingAdditionalAddress.value  = this.addressIntervention.additionalAddress
      }
    },
    'form.applicant.value': function () {
      this.resetBillingAddress()
      this.fetchApplicantAddress()
    },
    'form.file.value'() {
      if (this.form.file.value) {
        this.didAddFile()
      }
    },
    'useAddressInterventionForBilling': function(){
      if(this.useAddressInterventionForBilling){
        this.form.billingAddress.value = this.addressIntervention.address
        this.form.billingPostalCode.value  = this.addressIntervention.postalCode
        this.form.billingCity.value  = this.addressIntervention.city
        this.form.billingAdditionalAddress.value  = this.addressIntervention.additionalAddress
      }else{
        this.resetBillingAddress()
        this.fetchApplicantAddress()
      }
    }
  },

  methods: {
    resetBillingAddress(){
      this.form.billingAddress.value = null
      this.form.billingPostalCode.value  = null
      this.form.billingCity.value  = null
      this.form.billingAdditionalAddress.value  = null
    },

    //region fetch
    setOptionField() {
      this.fetchTechnicians()
      this.fetchInterventionTypes()
    },

    fetchTechnicians() {
      api
        .get(`/technician`)
        .then(response => {
          this.technicians = [{value: null, text: this.$i18n.t('TechnicianSelect'), disabled: true}]
          response.data.map(technician => {
            if(technician != null){
              this.technicians.push({value: technician.id, text: `${technician.firstName + ' ' + technician.lastName}`})
            }
          })
        })
    },

    fetchInterventionTypes(){
      api
        .get(`/interventionType`)
        .then(response => {
          this.interventionTypes.push({value: null, text: this.$i18n.t('TypeSelect'), disabled: true})
          response.data.map(interventionType => {
            this.interventionTypes.push({value: interventionType.id, text: this.$i18n.t(interventionType.slug_key)})
          })
        })
    },

    fetchDevices() {
      api
        .get(`/device/getDevicesByAddressIntervention?addressInterventionId=${this.addressIntervention.id}`)
        .then(response => {
          this.deviceOptions = [{value: null, text: this.$i18n.t('device.select'), disabled: true}]
          response.data.map(device => {
            if(device != null){
              this.deviceOptions.push({value: device.id, text: device.name})
            }
          })
        })
    },

    fetchApplicantAddress(){
      if(this.form.applicant.value != null){
        api
          .get(`/client/${this.form.applicant.value}`)
          .then(response => {
            this.applicant = response.data
            if(this.applicant.address != null){
              this.form.billingAddress.value = this.applicant.address
              this.form.billingPostalCode.value  = this.applicant.postalCode
              this.form.billingCity.value  = this.applicant.city
              this.form.billingAdditionalAddress.value  = this.applicant.additionalAddress
            }
          })
      }
    },
    //endregion
    setAddressIntervention(addressIntervention) {
      this.addressIntervention = addressIntervention
    },

    showCreateAddressInterventionModal(){
      this.$bvModal.show('addressIntervention-create-modal')
    },

    didCreateAddressIntervention(response){
      this.setAddressIntervention(response)
      this.$bvModal.hide('addressIntervention-create-modal')
    },

    getEstimatedStartDateInfos(state, invalidFeedBack, value) {
      this.form.estimatedStartDate.state = state;
      this.form.estimatedStartDate.invalidFeedback = invalidFeedBack;
      this.form.estimatedStartDate.value = value;

      this.automaticEndDate = new Date(value + 3600000);
    },

    getEndDateInfos(state, invalidFeedBack, value) {
      this.form.estimatedEndDate.state = state;
      this.form.estimatedEndDate.invalidFeedback = invalidFeedBack;
      this.form.estimatedEndDate.value = value;
    },

    onSubmit() {
      if (this.form.estimatedStartDate.value >= this.form.estimatedEndDate.value) {
        this.$bvToast.toast(this.$i18n.t("problemDateStartEnd"), {
          autoHideDelay: 20000,
          toaster: 'b-toaster-top-center',
          title: this.$i18n.t("problemDate")
        })
        return
      }

      var headers = { 'content-type': 'multipart/form-data' }

      let data = new FormData()
      data.append("nbFiles", this.files.length)
      if (this.files) {
        for(let i = 0; i < this.files.length; i++) {
          data.append(`file-${i}`, this.files[i].file)
        }
      }

      data.append('typeId', this.form.type.value)
      data.append('technicianId', this.form.technician.value)
      data.append('addressInterventionId', this.addressIntervention.id)
      data.append('applicantId', this.form.applicant.value)
      if(this.form.device.value){
        data.append('deviceId', this.form.device.value)
      }
      data.append('estimatedEndDate', new Date( this.form.estimatedEndDate.value).getTime() - 1)
      data.append('estimatedStartDate', new Date( this.form.estimatedStartDate.value).getTime())
      if (this.form.description.value && this.form.description.value.trim() !== "") {
        data.append('description', this.form.description.value)
      }

      data.append('billingAddress', this.form.billingAddress.value)
      data.append('billingPostalCode', this.form.billingPostalCode.value)
      data.append('billingCity', this.form.billingCity.value)
      if(this.form.billingAdditionalAddress.value && this.form.billingAdditionalAddress.value.trim() !== ""){
        data.append('billingAdditionalAddress', this.form.billingAdditionalAddress.value)
      }
      data.append('recordBillingToApplicant', this.form.recordBillingToApplicant.value)

      this.isSending = true

      api({
        method: 'POST',
        url: `intervention`,
        data: data,
        headers: headers
      })
        .then((response) => {
          this.$router.push({
            name: 'InterventionIndex'
          }, () => {
            this.$nextTick(() => {
              let interventionName = this.formatDate(this.form.estimatedStartDate.value)
              this.successToast(interventionName)
            })
          })
        })
        .catch((error) => {
          this.isSending = false
          if (error.response.status === 418) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]["state"] = false
            this.form[invalidField]["invalidFeedback"] = error.response.data.message
          }else if(error.response.status === 420){
           alert(error.response.data.message)
          }
        });
    },

    successToast(interventionName) {
      this.$bvToast.toast(this.$i18n.t('Intervention') + ' "' + interventionName + '" ' + this.$i18n.t('added'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    //region document
    didAddFile() {
      let extension = this.checkExtension(this.form.file.value.name).toUpperCase();
      this.files.push({
        file: this.form.file.value,
        name: this.form.file.value.name,
        extension: extension,
        url: window.URL.createObjectURL(this.form.file.value),
        type: (extension !== "JPG" && extension !== "JPEG" && extension !== "PNG") ? "DOCUMENT" : "PHOTO"
      })
    },

    checkExtension(filename) {
      return filename.split('.').pop();
    },

    removeFile(fileToDelete) {
      this.files.forEach((file, index) => {
        if (fileToDelete === file) {
          this.files.splice(index, 1)
          if (index === this.files.length) {
            this.form.file.value = null;
            this.form.file.state = null;
            this.form.file.invalidFeedback = null;
          }
        }
      })
    },

    zoomOnImage(imageSrc) {
      this.ui.zoomOnImageSrc = imageSrc
    },

    didCloseZoomOnImage() {
      this.ui.zoomOnImageSrc = null
    },
  //  endregion
  }
}
</script>

<style scoped>
.remove-photo-icon{
  top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/views/intervention/InterventionCreate.vue